<template>
  <div class="u-wrap" >
    <div class="sp-top" >
      <img :src="obj.tp" @click="preImage(obj.tp)" />
    </div>
    <div class="sp-content" >
      <div class="sp-content-top">
        <div class="jfsc-t u-line-1">{{ obj.mc }}</div>
        <div class="kc">库存 {{obj.sl}}件</div>
        <div class="jf-b">
          <span class="jf">{{ obj.jfjz }}</span
          >积分
          <span class="jz">价值￥{{ obj.scjz }}</span>
        </div>
      </div>
      <div class="sp-content-bottom">
        <div class="card">
          <div class="sp-title">商品描述</div>
          <div class="sp-del">
            {{ obj.ms }}
          </div>
          <div class="sp-title">商品领取地址</div>
          <div class="sp-del">
            {{ splqdz }}
          </div>
        </div>
      </div>
    </div>
    <div class="sp-bottom">
      <van-button v-if="obj.sl>0" class="button" ripple @click="clickSumbit">立即兑换</van-button>
      <van-button v-else-if="obj.sl==0" class="button" ripple >商品已兑完</van-button>
    </div>
  </div>
</template>

<script>
import { getAction, postAction } from '@/api/manage'
import { ImagePreview } from 'vant'
import OpenIdMixin from '@/views/common/mixins/openId-mixin.js'
import Vue from 'vue'
export default {
   mixins: [OpenIdMixin], 
  data() {
    return {
      jf: 0,
      dataList: [],
      type: '01',
      id: '',
      obj: {},
      splqdz:'',
    }
  },
  created() {
    this.id = this.$route.query.id
    this.splqdz =  this.$route.query.splqdz
    this.getData()
  },
  mounted() {},
  methods: {
    getData() {
      let params = { id: this.id }
      let url = '/zhshj/jfscspgl/page'
      getAction(url, params).then((res) => {
        if (res.success) {
          let obj = res.result.records[0]
          this.obj = obj
        }
      })
    },
    clickItem(item) {},
    preImage(img) {
      let imgList = []
      imgList.push(img)
      ImagePreview({
        images: imgList,
      })
    },
    clickSumbit() {
      this.$dialog
        .confirm({
          title: '提示',
          message: '您确定要兑换该商品',
          confirmButtonText: '确定',
          confirmButtonColor: '#3f8ffb',
        })
        .then(() => {
          this.sumbitData()
        })
    },
    sumbitData(){
      let rzInfo = this.getSmrzData();
      let params = {spId:this.obj.id,xm:rzInfo.wechatName,sfzh:rzInfo.idNumber,dh:rzInfo.phone,sysOrgCode:rzInfo.sysOrgCode,czpt:'3'}
      let url = '/zhshj/jfscdhjl/add'
      postAction(url, params).then((res) => {
        let code = 0;
        let message = '';
        let dhm = ''
        if (res.success) {
         code =1
         message = '请到线下固定的地点提供兑换码领取您兑换的商品';
         if(res.result){
           dhm = res.result.dhm
         }
        }else{
         message = res.message 
        }

      this.$router.replace({
         path:'/gzfw/jfsc-success',
         query:{code,message,dhm}
      })

      })

    }
  },
  beforeDestroy() {},
}
</script>

<style lang="less" scoped>
.u-wrap {
  display: flex;
  flex-direction: column;
  background: #f9f9f9;
  min-height: 100vh;
  padding-bottom: 75px;
  box-sizing: border-box;
}

.sp-top {
  width: 100%;
  height: 300px;


  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.sp-content {
  position: relative;
  margin-top: -25px;
  border-radius: 15px 15px 0 0;
  min-height: 300px;
  overflow: hidden;

  .sp-content-top {
    background: #ffffff;
    padding: 15px;

    .jfsc-t {
      font-weight: 500;
      font-size: 21px;
      color: #333333;
      margin-bottom: 10px;
    }
    .kc {
      font-weight: 400;
      font-size: 12px;
      color: #666666;
      margin-bottom: 5px;
    }

    .jf-b {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #666666;
    }

    .jf {
      font-weight: 500;
      font-size: 24px;
      color: #ff6a38;
      margin-right: 2px;
    }

    .jz {
      margin-left: 30px;
    }
  }

  .sp-content-bottom {
    background: #f9f9f9;
    padding: 10px;

    .card {
      background: #ffffff;
      border-radius: 3px;
      padding: 12px 14px;

      .sp-title {
        font-weight: 500;
        font-size: 18px;
        color: #333333;
        margin-bottom: 10px;
      }

      .sp-del {
        font-size: 14px;
        color: #666666;
        margin-bottom: 16px;
      }
    }
  }
}

.sp-bottom {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 75px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;

  .button {
    width: 90%;
    height: 40px;
    line-height: 40px;
    background: #ff6a38;
    border-radius: 20px;
    font-weight: 500;
    font-size: 18px;
    color: #ffffff;
  }
}
</style>
